<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"  
  >
    <path d="M7.10433 1.39899C7.28789 1.02705 7.64499 0.841244 8.00195 0.841553C8.35832 0.841862 8.71455 1.02767 8.8978 1.39899L10.8282 5.31049L15.1448 5.93772C15.9651 6.05691 16.2926 7.06488 15.699 7.64342L12.5755 10.6881L13.3129 14.9872C13.453 15.8042 12.5956 16.4271 11.8619 16.0414L8.00106 14.0116L4.14018 16.0414C3.40655 16.4271 2.54913 15.8041 2.68924 14.9872L3.4266 10.6881L0.303081 7.64342C-0.290438 7.06488 0.0370772 6.05691 0.857295 5.93772L5.17389 5.31048L7.10433 1.39899ZM8.00195 13.0116C8.1615 13.0118 8.32101 13.0501 8.4664 13.1265L12.3273 15.1563L11.5899 10.8571C11.5343 10.5327 11.6418 10.2017 11.8775 9.97201L15.001 6.92733L10.6844 6.30009C10.3587 6.25276 10.0772 6.04819 9.9315 5.75305L8.00195 1.84335V13.0116Z" fill="#FFC259"/>
  </svg>
</template>
